import React, { useState,useRef } from "react";
import { Link, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { insertFacultyNewUser } from "../../app/redux/slices/facultySlice";
import { routePath as RP } from "../../app/components/router/routepath";
import { useNavigate } from "react-router-dom";
import "../../pages/styles.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Swal from "sweetalert2";
import { uploadFormFilesReq } from "../../api/scholarshipapplication/scholarshipapplication";
export default function SignUpPage() {
  const [step, setStep] = useState(0);
  const [userType, setUserType] = useState("faculty"); // default to student
  const [showPassword, setShowPassword] = useState(false);
const [workErrors, setWorkErrors] = useState({});

const fileInputRef = useRef(null);
  const [basicDetails, setBasicDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
      documents: [],
  });

  const [educationList, setEducationList] = useState([]);
  const [eduErrors, setEduErrors] = useState({});
  const [education, setEducation] = useState({ degree: "", college: "", year: "" });
  const [showEducationFields, setShowEducationFields] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
/* ================= WORK DETAILS ================= */
  const [workList, setWorkList] = useState([]);
  const [work, setWork] = useState({
    organization: "",
    startDate: "",
    endDate: "",
    role: "",
    currentlyWorking: false,
  });
  const [showWorkFields, setShowWorkFields] = useState(false);
  const [editWorkIndex, setEditWorkIndex] = useState(null);

  /* ================= VERIFICATION ================= */
  const [verification, setVerification] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});

  // Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.signup);

  // --- Validation regex ---
  const nameRegex = /^[A-Za-z]{0,150}$/;
const emailRegex =
/^(?!.*\.\.)[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;

    const usernameRegex = /^[A-Za-z0-9_]{3,20}$/;
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/;
const phoneRegex = /^[1-9]\d{9}$/;
  const courseRegex = /^[A-Za-z0-9.,(){}"':;/|\/\-\s]{0,150}$/;
  const collegeRegex = /^[A-Za-z\s]{0,250}$/;
  const roleRegex = /^[A-Za-z0-9\s.]{0,150}$/;
  const organizationRegex = /^[A-Za-z\s]{0,250}$/;
  const yearRegex = /^[0-9]{4}$/;
  const blockSpecialCharsRegex = /^[^@#$%^*]*$/;


 const isValidEmail = (email) => {
    email = email.trim();

    // Basic regex: no spaces, contains @, proper chars
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) return false;

    const [local, domain] = email.split("@");
    if (!local || !domain) return false;

    // Local part rules
    if (local.startsWith(".") || local.endsWith(".")) return false;
    if (local.includes("..")) return false;

    // Domain rules
    if (domain.startsWith(".") || domain.endsWith(".")) return false;
    if (domain.includes("..")) return false;

    const domainParts = domain.split(".");
    if (domainParts.length < 2) return false;

    // Last two domain parts cannot be same (reject domain.com.com)
    const lastIndex = domainParts.length - 1;
    if (domainParts[lastIndex] === domainParts[lastIndex - 1]) return false;

    // Each domain part must contain only letters, numbers, hyphen (no special chars)
    for (let part of domainParts) {
      if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;
      if (part.startsWith("-") || part.endsWith("-")) return false; // no hyphen at start/end
    }

    return true;
  };


  // --- Validation per step ---
  const validateStep = () => {
    let stepErrors = {};

    if (step === 0) {
      if (!basicDetails.firstName || !nameRegex.test(basicDetails.firstName))
        stepErrors.firstName = "First name required (alphabets only, max 150).";
      if (!basicDetails.lastName || !nameRegex.test(basicDetails.lastName))
        stepErrors.lastName = "Last name required (alphabets only, max 150).";
     if (!basicDetails.email) {
        stepErrors.email = "Email is required.";
      } else if (!isValidEmail(basicDetails.email)) {
        stepErrors.email = "Enter a valid email.";
      }
      if (!basicDetails.phone) {
      stepErrors.phone = "Phone number is required.";
    } else if (!phoneRegex.test(basicDetails.phone)) {
      stepErrors.phone = "Phone number must be 10 digits.";
    }
     // Date of Birth
if (!basicDetails.dob) {
  stepErrors.dob = "Date of birth is required.";
} else {
  const dob = new Date(basicDetails.dob);
  const todayDate = new Date();

  if (dob > todayDate) {
    stepErrors.dob = "Date of birth cannot be in the future.";
  } else {
    let age = todayDate.getFullYear() - dob.getFullYear();
    const monthDiff = todayDate.getMonth() - dob.getMonth();
    const dayDiff = todayDate.getDate() - dob.getDate();

    // Adjust age if birthday not yet reached this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    if (age < 10) {
      stepErrors.dob = "Age must be at least 10 years.";
    } else if (age > 79) {
      stepErrors.dob = "Age cannot be more than 79 years.";
    }
  }
}

      if (!basicDetails.gender) stepErrors.gender = "Gender is required.";
    }
    
    if (step === 1) {
  if (educationList.length === 0) {
    stepErrors.education = "At least one qualification is required.";
  }

  if (workList.length === 0) {
    stepErrors.work = "At least one work detail is required.";
  }
}


     if (step === 2) {
    // Email / Email
    const username = verification.username.trim();

     if (!username) {
        stepErrors.username = "Email is required.";
      } else if (!isValidEmail(username)) {
        stepErrors.username = "Enter a valid email.";
      }

    // Password
    if (!verification.password) {
      stepErrors.password = "Password is required.";
    } else if (!passwordRegex.test(verification.password)) {
      stepErrors.password =
        "Password must be min 6 chars, include letters, numbers & special char.";
    }
  }

    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  // --- Step navigation ---
  const nextStep = () => {
    if (validateStep()) setStep(step + 1);
  };
  const prevStep = () => setStep(step - 1);

  const [selectedFiles, setSelectedFiles] = useState([]); // newly selected files
const [filesList, setFilesList] = useState( []); // display names
const [fileSelected, setFileSelected] = useState(false);
const [newFileSelected, setNewFileSelected] = useState(false);
 const [existingDocFiles, setExistingDocFiles] = useState([]);
const [originalFiles, setOriginalFiles] = useState([]);
const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  if (!files || files.length === 0) return;

  setSelectedFiles(files);               // store File objects
  setFilesList(files.map(f => f.name));  // store names for display

  setBasicDetails({ ...basicDetails, documents: files }); // attach to basicDetails
  setFileSelected(true);
};
  // Upload files function returns uploaded file names
  const uploadFiles = async (applicationId) => {
    if (selectedFiles.length < 1) return [];

    const formDataPayload = new FormData();
    selectedFiles.forEach((file) => formDataPayload.append("FormFiles", file));
    formDataPayload.append("TypeofUser", "faculty");
    formDataPayload.append("id", applicationId);

    try {
      await uploadFormFilesReq(formDataPayload);

      // Return names of uploaded files for merging
      return selectedFiles.map(f => f.name);
    } catch (ex) {
      console.error("File upload failed:", ex);
      return [];
    }
  };
  const handleRemoveSingleFile = (index) => { 
    
  const updatedFiles = existingDocFiles.filter((_, i) => i !== index);
  //setExistingDocFiles(updatedFiles);
   setFilesList(updatedFiles);

  /*setFormData(prev => ({
    ...prev,
    files: updatedFiles,
    fileName: updatedFiles.length > 0 ? updatedFiles.join("|") : "",
  }));*/
   // flags
  if (updatedFiles.length === 0) {
    setFileSelected(false);
    setNewFileSelected(false);
  }

  // clear input
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
  
};
const handleClear = () => {
  setSelectedFiles([]);
  setFilesList([]);
  setFileSelected(false);
  setBasicDetails({ ...basicDetails, documents: [] }); // clear documents
  if (fileInputRef.current) fileInputRef.current.value = null;
};

  // --- Save (Signup dispatch) ---
  const handleSave = async() => {
    
    if (!validateStep()) return;
  const createdBy = `${basicDetails.firstName} ${basicDetails.lastName}`.trim();
const payload = {
  FirstName: basicDetails.firstName,
  LastName: basicDetails.lastName,
  Email: basicDetails.email,            // ✅ correct field
  Phone: basicDetails.phone,
  DateofBirth: basicDetails.dob,        // ✅ rename
  Gender: basicDetails.gender,
  UserName: verification.username,      // ✅ rename
  PasswordHash: verification.password,  // ✅ raw password
  RoleId:  5,
  Education: JSON.stringify(educationList) ,
  // ✅ backend expects string
   Work: JSON.stringify(workList), // ✅ ADDED
  CreatedBy: createdBy,  
};


   // 1️⃣ Insert user and get ID
  const userId = await dispatch(insertFacultyNewUser(payload));
  if (!userId) return; // stop if insertion failed

  // 2️⃣ Upload documents if any
  if (basicDetails.documents && basicDetails.documents.length > 0) {
    try {
      await uploadFiles(userId);
    } catch (err) {
      console.error("File upload failed:", err);
      Swal.fire({
        text: "Documents upload failed!",
        icon: "error",
      });
      return;
    }
  }

  // 3️⃣ Show success alert after everything
  await Swal.fire({
    text: "Signup successful!",
    icon: "success",
    confirmButtonText: "OK",
  });

  // 4️⃣ Navigate to login
  navigate("/login");
};

  // --- Education handlers ---
  const addEducation = () => {
  let errorsObj = {};

  if (!education.degree.trim()) {
    errorsObj.degree = "Course is required.";
  }

  if (!education.college.trim()) {
    errorsObj.college = "College / University is required.";
  }

  if (!education.year) {
    errorsObj.year = "Year is required.";
  } else if (!yearRegex.test(education.year)) {
    errorsObj.year = "Year must be 4 digits.";
  }
  

  if (Object.keys(errorsObj).length > 0) {
    setEduErrors(errorsObj);
    return; // ⛔ BLOCK SAVE
  }

  setEducationList([...educationList, education]);
  setEducation({ degree: "", college: "", year: "" });
  setShowEducationFields(false);
  setEduErrors({});
};


  const updateEducation = (index) => {
    let errorsObj = {};
    if (!courseRegex.test(education.degree)) errorsObj.degree = "Invalid course.";
    if (!collegeRegex.test(education.college)) errorsObj.college = "Invalid college/university.";
    if (!yearRegex.test(education.year)) errorsObj.year = "Year must be 4 digits.";

    if (Object.keys(errorsObj).length > 0) {
      setEduErrors(errorsObj);
      return;
    }

    const updated = [...educationList];
    updated[index] = education;
    setEducationList(updated);
    setEditIndex(null);
    setEducation({ degree: "", college: "", year: "" });
    setEduErrors({});
  };

  const deleteEducation = (index) => {
    const updated = educationList.filter((_, i) => i !== index);
    setEducationList(updated);
  };

const addWork = () => {
  let errorsObj = {};

if (!work.organization.trim()) {
  errorsObj.organization = "Organization is required.";
}

if (!work.startDate) {
  errorsObj.startDate = "Start date is required.";
}

if (!work.currentlyWorking && !work.endDate) {
  errorsObj.endDate = "End date is required.";
}

if (!work.role.trim()) {
  errorsObj.role = "Role is required.";


} else if (!work.currentlyWorking && !roleRegex.test(work.role)) {
  errorsObj.role = "Invalid role.";
}

  if (Object.keys(errorsObj).length > 0) {
    setWorkErrors(errorsObj);
    return;
  }

  setWorkList([...workList, work]);
  setWork({
    organization: "",
    startDate: "",
    endDate: "",
    role: "",
    currentlyWorking: false,
  });
  setShowWorkFields(false);
  setWorkErrors({});
};


const updateWork = (index) => {
  let errorsObj = {};

  if (!organizationRegex.test(work.organization)) {
    errorsObj.organization = "Invalid organization name.";
  }

  if (!work.startDate) {
    errorsObj.startDate = "Start date is required.";
  }

  if (!work.currentlyWorking && !work.endDate) {
    errorsObj.endDate = "End date is required.";
  }

  if (!work.currentlyWorking && !roleRegex.test(work.role)) {
    errorsObj.role = "Invalid role.";
  }

  if (Object.keys(errorsObj).length > 0) {
    setWorkErrors(errorsObj);
    return;
  }

  const updated = [...workList];
  updated[index] = work;
  setWorkList(updated);
  setEditWorkIndex(null);
  setWorkErrors({});
  setWork({
    organization: "",
    startDate: "",
    endDate: "",
    role: "",
    currentlyWorking: false,
  });
};



const deleteWork = (index) => {
  setWorkList(workList.filter((_, i) => i !== index));
};

  // --- DOB restrictions ---
  const today = new Date().toISOString().split("T")[0];
  const minDob = new Date();
  minDob.setFullYear(minDob.getFullYear() - 79);
  const minDobStr = minDob.toISOString().split("T")[0];

  const isStepCompleted = (stepIndex) => {
    if (stepIndex === 0) {
      return (
        basicDetails.firstName &&
        nameRegex.test(basicDetails.firstName) &&
        basicDetails.lastName &&
        nameRegex.test(basicDetails.lastName) &&
        basicDetails.email &&
        isValidEmail(basicDetails.email) &&
        basicDetails.phone &&
        phoneRegex.test(basicDetails.phone) &&
        basicDetails.dob &&
        basicDetails.gender
      );
    }
    if (stepIndex === 1) return educationList.length > 0;
    return true;
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        {/* Header */}
        <div className="signup-header">
          <h2>Faculty Sign up</h2>
          <p>
            Already a member?{" "}
            <Link to={RP.login} state={{ userType }} className="signup-link">
              Sign in
            </Link>
          </p>
        </div>

        {/* Step navigation */}
        <div className="signup-steps">
          {["Basic Details", "Qualification", "Verification"].map((label, i) => (
            <div key={i} className="step-item">
              <div
                className={`step-circle ${i === step ? "active" : ""} ${
                  i > 0 && !isStepCompleted(i - 1) ? "disabled" : ""
                }`}
                onClick={() => {
                  if (i === 0 || isStepCompleted(i - 1)) setStep(i);
                }}
                title={label}
              >
                {i + 1}
              </div>
              <span className="step-label">{label}</span>
            </div>
          ))}
        </div>

        {/* Error / Loading messages */}
        {loading && <p className="loading-text">Processing...</p>}
      

        {/* Step Content */}
        {/* Step 0: Basic Details */}
        {step === 0 && (
          <div>
            <h3 className="section-title">Basic Details</h3>
            <div className="row">
              <div className="form-group">
                <label>First Name *</label>
                <input
                  type="text"
                  value={basicDetails.firstName}
                  onChange={(e) =>
                    nameRegex.test(e.target.value) &&
                    setBasicDetails({ ...basicDetails, firstName: e.target.value })
                  }
                  className={errors.firstName ? "input-error" : ""}
                  placeholder="First Name"
                />
                {errors.firstName && <p className="error-text">{errors.firstName}</p>}
              </div>
              <div className="form-group">
                <label>Last Name *</label>
                <input
                  type="text"
                  value={basicDetails.lastName}
                  onChange={(e) =>
                    nameRegex.test(e.target.value) &&
                    setBasicDetails({ ...basicDetails, lastName: e.target.value })
                  }
                  className={errors.lastName ? "input-error" : ""}
                  placeholder="Last Name"
                />
                {errors.lastName && <p className="error-text">{errors.lastName}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Email *</label>
<input
  type="email"
  value={basicDetails.email}
  onChange={(e) =>
    setBasicDetails({ ...basicDetails, email: e.target.value })
  }
  className={errors.email ? "input-error" : ""}
  placeholder="Email"
/>


                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>
              <div className="form-group">
                <label>Phone *</label>
                <input
                  type="text"
                  maxLength={10}
                  value={basicDetails.phone}
                  onChange={(e) => {
  const value = e.target.value;

  // allow only numbers
  if (!/^\d*$/.test(value)) return;

  // block starting with 0
  if (value.length === 1 && value === "0") {
    setErrors(prev => ({
      ...prev,
      phone: "Phone number should not start with 0."
    }));
    return;
  }

  // clear error if valid typing
  setErrors(prev => ({ ...prev, phone: "" }));

  setBasicDetails({ ...basicDetails, phone: value });
}}

                  className={errors.phone ? "input-error" : ""}
                  placeholder="Phone"
                />
                {errors.phone && <p className="error-text">{errors.phone}</p>}
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>Date of Birth *</label>
                <input
  type="date"
  value={basicDetails.dob}
  max={today}
  min={minDobStr}
  onChange={(e) =>
    setBasicDetails({ ...basicDetails, dob: e.target.value })
  }
  className={errors.dob ? "input-error" : ""}
/>

                {errors.dob && <p className="error-text">{errors.dob}</p>}
              </div>
              <div className="form-group">
                <label>Gender *</label>
                <div className="gender-group">
                  <label>   Male
                  </label>
                    <input
                      type="radio"
                      name="gender"
                      checked={basicDetails.gender === "Male"}
                      onChange={() => setBasicDetails({ ...basicDetails, gender: "Male" })}
                    />
                 
                  <label>  Female
                  </label>
                    <input
                      type="radio"
                      name="gender"
                      checked={basicDetails.gender === "Female"}
                      onChange={() => setBasicDetails({ ...basicDetails, gender: "Female" })}
                    />
                  
                </div>
                {errors.gender && <p className="error-text">{errors.gender}</p>}
              </div>
            </div>
            
              <div className="form-group col-12">
                <label>Upload Profile Photo</label>
                <input
                 type="file"
                  accept="image/*"   
                  name="documents"
                  onChange={handleFileChange}
                 // multiple
                  ref={fileInputRef}
                 // disabled={isViewMode}
                />

                {fileSelected && filesList.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-sm btn-danger mt-2"
                    onClick={handleClear}
                      style={{ marginTop: "10px" }}
                  >
                    Clear
                  </button>
                )}

               {filesList.length > 0 && (
    <div className="d-flex flex-column mt-2 rounded"style={{ marginTop: "5px" }}>
      {filesList.map((fileName, index) => (
        <div
          key={index}
          className="d-flex align-items-center justify-content-between border rounded p-2 mb-1"
          style={{
          gap: "12px",
          paddingLeft: "14px",
          paddingRight: "12px",
          color:"black"
        }}
        >
          <span>{fileName}</span>
          <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveSingleFile(index)}
              style={{ marginLeft: "5px" }}
            >
              ×
            </button>
        </div>
      ))}
    </div>
  )}


                    
                  </div>
              
              
          </div>
        )}

        {/* Education Step */}
        {step === 1 && (
            <>
          <div>
            <div className="education-header">
              <h3>Qualification</h3>
              {!showEducationFields && editIndex === null && (
                <button onClick={() => setShowEducationFields(true)} className="add-btn">
                  + Add Qualification
                </button>
              )}
            </div>

            {errors.education && <p className="error-text">{errors.education}</p>}

           {/*{educationList.length > 0 && (
              <div className="education-grid header">
                <div>Course</div>
                <div>College / University</div>
                <div>Year</div>
                <div>Actions</div>
              </div>
            )}
*/}

            {educationList.map((edu, index) =>
              editIndex === index ? (
                <div className="education-grid" key={index}>
                   <div className="field-group">
    <label className="field-label">Course</label>
                  <input
  type="text"
  placeholder="Course"
  value={education.degree}
  onChange={(e) => setEducation({ ...education, degree: e.target.value })}
/>
</div>
{eduErrors.degree && <p className="error-text">{eduErrors.degree}</p>}
  <div className="field-group">
    <label className="field-label">College / University</label>
<input
  type="text"
  placeholder="College / University  "
  value={education.college}
  onChange={(e) => setEducation({ ...education, college: e.target.value })}
/>
</div>
{eduErrors.college && <p className="error-text">{eduErrors.college}</p>}
<div className="field-group">
    <label className="field-label">Year</label>
<input
  type="text"
  placeholder="Year"
  value={education.year}
  onChange={(e) => setEducation({ ...education, year: e.target.value })}
  maxLength={4}
/>
</div>
{eduErrors.year && <p className="error-text">{eduErrors.year}</p>}


                  <div className="sign-action-btns">
                    <button onClick={() => updateEducation(index)} className="sign-action-btn">
                      Save
                    </button>
                    <button
                      onClick={() => {
                        setEditIndex(null);
                        setEducation({ degree: "", college: "", year: "" });
                      }}
                      className="sign-action-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                
                  <div className="education-grid" key={index}>
  <div className="label-value">
    <span className="label">Course</span>
    <span className="value">{edu.degree}</span>
  </div>

  <div className="label-value">
    <span className="label">College / University</span>
    <span className="value">{edu.college}</span>
  </div>

  <div className="label-value">
    <span className="label">Year</span>
    <span className="value">{edu.year}</span>
  </div>

  <div className="sign-action-btns">
    <button
      onClick={() => {
        setEditIndex(index);
        setEducation(edu);
        setShowEducationFields(false);
      }}
      className="sign-action-btn"
    >
      Edit
    </button>
    <button onClick={() => deleteEducation(index)} className="sign-action-btn">
      Delete
    </button>
  </div>
</div>

               
              )
            )}

            {showEducationFields && editIndex === null && (
              <div className="education-grid">
                  <div className="form-group">
    <label>Specialization
<span className="required">*</span></label>   
<input
  type="text"
  placeholder="Course"
  value={education.degree}
  onChange={(e) => {
    const value = e.target.value;
    if (blockSpecialCharsRegex.test(value)) {
      setEducation({ ...education, degree: value });
    }
  }}
/>

</div>


    <div className="form-group">
    <label>College / University Name <span className="required">*</span></label>                  

                 <input
  type="text"
  placeholder="College / University Name"
  value={education.college}
  onChange={(e) => {
    const value = e.target.value;
    if (blockSpecialCharsRegex.test(value)) {
      setEducation({ ...education, college: value });
    }
  }}
/>

</div>

             <div className="form-group">
    <label>Year of Passing<span className="required">*</span></label>   

                  <input
                    type="text"
                    placeholder="Year"
                    value={education.year}
                    maxLength={4}
                    onChange={(e) => {
    const value = e.target.value;
    // Allow only numbers while typing
    if (/^\d*$/.test(value)) {
      setEducation({ ...education, year: value });
    }
  }}
                  />
                  </div>
                 

                <div className="sign-action-btns">
                  <button onClick={addEducation} className="sign-action-btn">
                    Save
                  </button>
                  <button
                    onClick={() => {
                      setShowEducationFields(false);
                      setEducation({ degree: "", college: "", year: "" });
                        setEduErrors({}); // 🔹 clear errors on Cancel
                    }}
                    className="sign-action-btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
             {/* Show errors only after clicking Save */}
    {Object.keys(eduErrors).length > 0 && (
      <div className="error-block">
        {eduErrors.degree && <p className="error-text">{eduErrors.degree}</p>}
        {eduErrors.college && <p className="error-text">{eduErrors.college}</p>}
        {eduErrors.year && <p className="error-text">{eduErrors.year}</p>}
      </div>
    )}
          </div>

<div style={{ marginTop: "40px" }}>
  <div className="education-header">
    <h3>Work Details</h3>
    {!showWorkFields && editWorkIndex === null && (
      <button onClick={() => setShowWorkFields(true)} className="add-btn">
        + Add Work
      </button>
    )}
  </div>
{errors.work && <p className="error-text">{errors.work}</p>}
 

  {workList.map((w, index) =>
    editWorkIndex === index ? (
      <div className="education-grid" key={index}>
        <div className="field-group">
          <label className="field-label">Organization</label>
          <input
            type="text"
            value={work.organization}
            onChange={(e) => setWork({ ...work, organization: e.target.value })}
          />
        </div>

        <div className="field-group">
          <label className="field-label">Start Date</label>
          <input
            type="date"
            
            value={work.startDate}
               max={new Date().toISOString().split("T")[0]} 
            onChange={(e) => setWork({ ...work, startDate: e.target.value })}
          />
        </div>

        <div className="field-group">
          <label className="field-label">End Date</label>
          <input
            type="date"
            value={work.endDate}
            disabled={work.currentlyWorking}
               min={work.startDate || undefined}  
            max={new Date().toISOString().split("T")[0]} 
            onChange={(e) => setWork({ ...work, endDate: e.target.value })}
          />
        </div>

        <div className="field-group">
          <label className="field-label">Role</label>
          <input
            type="text"
            value={work.role}
            onChange={(e) => setWork({ ...work, role: e.target.value })}
          />
        </div>

        <div className="field-group checkbox-group">
          <label className="work-checkbox">
            <input
              type="checkbox"
              checked={work.currentlyWorking}
              onChange={(e) =>
                setWork({
                  ...work,
                  currentlyWorking: e.target.checked,
                  endDate: e.target.checked ? "" : work.endDate,
                })
              }
            />
            Currently Working
          </label>
        </div>

        <div className="sign-action-btns">
          <button onClick={() => updateWork(index)} className="sign-action-btn">
            Save
          </button>
          <button
            onClick={() => {
              setEditWorkIndex(null);
              setWork({ organization: "", startDate: "", endDate: "", role: "", currentlyWorking: false });
              setWorkErrors({}); // clear errors on cancel
            }}
            className="sign-action-btn"
          >
            Cancel
          </button>
        </div>
      </div>
    ) : (
      <div className="education-grid" key={index}>
        <div className="label-value">
          <span className="label">Organization</span>
          <span className="value">{w.organization}</span>
        </div>

       {/* <div className="label-value">
          <span className="label">Start Date</span>
          <span className="value">{w.startDate}</span>
        </div>

        <div className="label-value">
          <span className="label">Currently Working</span>
          <span className="value">{w.currentlyWorking ? "Present" : w.endDate}</span>
        </div>*/}
        <div className="label-value">
  <span className="label">Duration</span>
  <span className="value">
    {w.startDate} – {w.currentlyWorking ? "Present" : w.endDate}
  </span>
</div>


        <div className="label-value">
          <span className="label">Role</span>
          <span className="value">{w.role}</span>
        </div>

        <div className="sign-action-btns">
          <button
            onClick={() => {
              setEditWorkIndex(index);
              setWork(w);
              setShowWorkFields(false);
            }}
            className="sign-action-btn"
          >
            Edit
          </button>
          <button onClick={() => deleteWork(index)} className="sign-action-btn">
            Delete
          </button>
        </div>
      </div>
    )
  )}

  {/* Add New Work */}
  {showWorkFields && editWorkIndex === null && (
    <div className="education-grid">
        <div className="form-group">
    <label>Organization<span className="required">*</span></label>
     <input
  type="text"
  placeholder="Organization"
  value={work.organization}
  onChange={(e) => {
    const value = e.target.value;
    if (blockSpecialCharsRegex.test(value)) {
      setWork({ ...work, organization: value });
    }
  }}
/>

      </div>
  <div className="form-group">
    <label>Start Date<span className="required">*</span></label>
      <input
        type="date"
         className="date-input"
  //data-placeholder="Start Date"
        value={work.startDate}
          max={new Date().toISOString().split("T")[0]} 
        onChange={(e) => setWork({ ...work, startDate: e.target.value })}
      />
      </div>

      {!work.currentlyWorking && (
       <div className="form-group">
    <label>End Date</label>
    <input
      type="date"
      className="date-input"
      value={work.endDate}
      min={work.startDate || undefined}
      max={new Date().toISOString().split("T")[0]}
      onChange={(e) =>
        setWork({ ...work, endDate: e.target.value })
      }
    />
  </div>
      )}

   <div className="form-group">
    <label>Role<span className="required">*</span></label>
        <input
  type="text"
  placeholder="Role"
  value={work.role}
  onChange={(e) => {
    const value = e.target.value;
    if (blockSpecialCharsRegex.test(value)) {
      setWork({ ...work, role: value });
    }
  }}
/>

      </div>

      <label style={{ alignItems: "center", gap: "6px" }}>
        <input
          type="checkbox"
          checked={work.currentlyWorking}
          onChange={(e) =>
            setWork({
              ...work,
              currentlyWorking: e.target.checked,
              endDate: e.target.checked ? "" : work.endDate,
            })
          }
        />
        Currently Working
      </label>

      <div className="sign-action-btns">
        <button onClick={addWork} className="sign-action-btn">
          Save
        </button>
        <button
          onClick={() => {
            setShowWorkFields(false);
            setWork({ organization: "", startDate: "", endDate: "", role: "", currentlyWorking: false });
            setWorkErrors({}); // clear errors on cancel
          }}
          className="sign-action-btn"
        >
          Cancel
        </button>
      </div>
    </div>
  )}
   {/* Show all errors in one block after Save */}
  {Object.keys(workErrors).length > 0 && (
    <div className="error-block">
      {workErrors.organization && <p className="error-text">{workErrors.organization}</p>}
      {workErrors.startDate && <p className="error-text">{workErrors.startDate}</p>}
     
      {workErrors.role && <p className="error-text">{workErrors.role}</p>}
      {workErrors.general && <p className="error-text">{workErrors.general}</p>}
    </div>
  )}
</div>



</>
        )}

        {/* Step 2: Verification */}
        {step === 2 && (
          <div className="verfiy">
            <h3>Verification</h3>
            <div className="row">
              <div className="form-group">
               <label>Email *</label>
<input
  type="email"
  placeholder="Enter your email"
  value={verification.username}
  onChange={(e) =>
    setVerification({ ...verification, username: e.target.value })
  }
  className={errors.username ? "input-error" : ""}
/>


{errors.username && <p className="error-text">{errors.username}</p>}

              </div>
              <div className="form-group">
  <label>Password *</label>

  <div className="password-wrapper">
    <input
      type={showPassword ? "text" : "password"}
      placeholder="Password"
      value={verification.password}
      onChange={(e) =>
        setVerification({ ...verification, password: e.target.value })
      }
      className={errors.password ? "input-error" : ""}
    />

    <span
      className="password-toggle"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
    </span>
  </div>

  {errors.password && <p className="error-text">{errors.password}</p>}
</div>

            </div>
          </div>
        )}

        {/* Navigation buttons */}
        <div className="nav-buttons">
          {step > 0 && (
            <button onClick={prevStep} className="nav-btn">
              Previous
            </button>
          )}
          {step < 2 && (
            <button onClick={nextStep} className="nav-btn">
              Next
            </button>
          )}
          {step === 2 && (
            <button onClick={handleSave} className="save-btn" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
